import React from "react";

import { Inputs, Row, Field } from "2g-form";
import { required } from "2g-validators-common";

import { ACZdrojeFromZdrojeTyp } from "b2b/components/autocompletes";
import { DateTime } from "b2b/renderers";
import { getCurrentMonday } from "b2b/utils/date";

import useMessages from "./i18n/useMessages";

const validatorRequired = required();
export default function FilterContent() {
  const messages = useMessages();
  const datumOd = getCurrentMonday();
  const datumDo = new Date(datumOd);
  datumDo.setDate(datumDo.getDate() + 13);
  return (
    <>
      <Row>
        <Field
          component={Inputs.DateTimePicker}
          date
          defaultValue={datumOd.getTime()}
          descriptionRenderer={DateTime}
          label={messages.filterLabelDateFrom()}
          milliseconds
          path="datumOd"
          required
          validators={validatorRequired}
        />
      </Row>
      <Row>
        <Field
          component={Inputs.DateTimePicker}
          date
          defaultValue={datumDo.getTime()}
          descriptionRenderer={DateTime}
          label={messages.filterLabelDateTo()}
          milliseconds
          path="datumDo"
          required
          validators={validatorRequired}
        />
      </Row>
      <Row>
        <ACZdrojeFromZdrojeTyp
          path="zdroj"
          label={messages.filterLabelZdroj()}
        />
      </Row>
    </>
  );
}
